import { render, staticRenderFns } from "./PersonalDetailsHealth.vue?vue&type=template&id=221fcf72"
import script from "./PersonalDetailsHealth.vue?vue&type=script&lang=js"
export * from "./PersonalDetailsHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports